import { jsx } from 'react/jsx-runtime';
import { ModalDestinationSelector } from '../DestinationSelector/ModalDestinationSelector.js';
import { useMutationMoveResourcesById } from '../../mutations/useMutationMoveResourcesById.js';
import React__default from 'react';

const defaultResources = [];
const ModalMoveResources = ({ resources = defaultResources, onClose, onMoveSuccess, open }) => {
  const mutationMoveResourcesById = useMutationMoveResourcesById();
  const resourcesToMoveIds = React__default.useMemo(() => resources.map((f) => f.id), [
    resources
  ]);
  return /* @__PURE__ */ jsx(ModalDestinationSelector, {
    open,
    onClose,
    title: "Move to...",
    resources,
    getIsNodeSelectable: (node) => {
      if (resourcesToMoveIds.includes(node.id)) {
        return false;
      }
      return true;
    },
    ctaButtonProps: {
      children: "Move",
      ["data-testid"]: "move-items-modal-move-button"
    },
    onDestinationSelect: (destination) => {
      mutationMoveResourcesById.mutate({
        resourceIds: resourcesToMoveIds,
        newParent: {
          id: destination.id,
          name: destination.title
        }
      }, {
        onSuccess: () => {
          onMoveSuccess();
        }
      });
    }
  });
};

export { ModalMoveResources };
//# sourceMappingURL=ModalMoveResources.js.map
